import AircraftSeats from './AircraftSeats';
export default AircraftSeats;
